<app-card class="top-card">
  <app-range-form [ranges]="filterRanges" (outputUpdate)="onRangeChange($event)" all />
</app-card>
@if (data(); as data) {
  <app-analytics-stats [period]="period()" [newUsers]="data.newUsers" [totalUsers]="data.totalUsers" />
  <app-analytics-visitors [period]="period()" [data]="data.visitors" />
  <app-analytics-page-views [period]="period()" [data]="data.visitors" />
  <app-analytics-page-usage [period]="period()" [pageUsage]="data.usage" />
} @else {
  <app-card i18n class="loader">Loading data...</app-card>
}
